module.exports = __webpack_public_path__ + "static/media/AtSign.d065d662.svg";